<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="getData"
      @openEdit="openEdit"
      @fullMember="fullMemberApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        :disabled="disabled"
        :checkedRowCount="checkedRowCount"
        @openEdit="openEdit"
        @chooseSku="chooseHxSkuVisible = true"
        @fullMember="fullMember"
        @remove="remove"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuEditForm
      :visible.sync="skuEditFormOpts.visible"
      :hxSpuCode="hxSpuCode"
      :hxSkuCode="skuEditFormOpts.hxSkuCode"
      :optType="skuEditFormOpts.optType"
      @close="getData"
    />

    <ChooseHxSku
      :visible.sync="chooseHxSkuVisible"
      url="/ecom/hx/sku/listByDemandWithoutSpuCode"
      :hxSkuStatus="['Y', 'Q']"
      reserve
      multiple
      confirm-on-close
      @confirm="chooseHxSkuConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'

import ChooseHxSku from '@/views/ecom/components/choose-hx-sku'
import SkuEditForm from '../sku-edit-form'

export default {
  mixins: [EditLoading, BaseTable],
  components: { PageMain, PageHeader, ChooseHxSku, SkuEditForm },
  props: {
    hxSpuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      chooseHxSkuVisible: false,
      checkedRows: [],
      skuEditFormOpts: { visible: false, optType: '', hxSkuCode: '' },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .ecomHxSkuListBySpuCodeApi({
          hxSpuCode: this.hxSpuCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    openEdit({ type: optType, data = {} }) {
      const { hxSkuCode = '' } = data
      console.log(optType)
      this.skuEditFormOpts = { visible: true, optType, hxSkuCode }
    },
    async chooseHxSkuConfirm(data) {
      if (!data || !data.length) return
      if (this.loadingOpen()) return

      const listCode = data.map(({ hxSkuCode }) => hxSkuCode)

      const res = await this.$api
        .ecomHxSpuBindSpuBySpuCodeApi({
          hxSpuCode: this.hxSpuCode,
          listCode: listCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.getData()
    },
    fullMember() {
      if (!this.checkedRowCount) {
        this.$message({ message: '请选择需要转正的SKU', type: 'warning' })
        return
      }
      const listHxSkuCode = this.checkedRows.map((row) => row.hxSkuCode)
      this.fullMemberApi(listHxSkuCode)
    },
    async fullMemberApi(listHxSkuCode) {
      const confirm = await this.$confirm(
        '是否要转正产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxSkuFullMemberApi({ listHxSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('转正失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '转正成功！',
        type: 'success',
      })
      this.getData()
    },
    async remove() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要移除的SKU',
          type: 'warning',
        })
        return
      }

      const confirm = await this.$confirm(
        '是否要移除所选产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).catch(() => null)
      if (!confirm) return
      if (this.loadingOpen()) return
      const listCode = this.checkedRows.map((item) => item.hxSkuCode)
      const res = await this.$api
        .ecomHxSpuRemoveSkuApi({ listCode, hxSpuCode: this.hxSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('移除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '移除成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
